module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return (_vm.isLoading) ? _c('loading') : _c('div', [_c('p', [_vm._v("De planning bestaat uit " + _vm._s(_vm.availableTerms.length) + " periodes: "), _c('em', [_vm._v(_vm._s(_vm.termNames))]), _vm._v(". Elke periode is verdeeld in vier blokken met 1 tot 4 opdrachten per blok.")]), _c('p', [_vm._v("U kunt de planning ook later nog aanpassen, zolang de periodes en blokken nog niet zijn begonnen.")]), _c('p', [_c('a', {
    staticClass: "tag",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.isInfoVisible = !_vm.isInfoVisible
      }
    }
  }, [_vm._v("Hoe pas ik de planning aan?")])]), (_vm.isInfoVisible) ? _c('div', [_c('h3', [_vm._v("Periode verplaatsen, blokken verlengen")]), _c('p', [_vm._v("Standaard duren de periodes 8 weken (2 weken voor elk blok, uitgaande van 100 lesminuten per week) en wordt er rekening gehouden met vakanties.")]), _c('p', [_vm._v("U kunt een periode eerder of later in het jaar laten beginnen door de titel van de periode omhoog en omlaag te verslepen.")]), _c('p', [_vm._v("Als u langer over een blok wilt doen (u wilt bijvoorbeeld tussendoor eigen opdrachten doen) kunt u het verlengen/verkorten door de pijltjes van het blok respectievelijk omlaag/omhoog te verslepen.")]), _c('p', [_c('img', {
    staticStyle: {
      "width": "296px",
      "margin": "2em auto"
    },
    attrs: {
      "src": "/build/img/planner.gif",
      "alt": "Planning aanpassen",
      "width": "296"
    }
  })]), _c('div', {
    staticClass: "note note--info"
  }, [_c('p', [_c('strong', [_vm._v("Let op:")]), _vm._v(" als een periode al is begonnen, kan deze niet meer versleept worden. U kunt nog wel de lengte van de blokken aanpassen, mits die blokken nog niet afgelopen zijn.")]), _c('p', [_vm._v("Houd er ook rekening mee dat de laatste periode moet eindigen binnen 54 weken na het begin van de eerste periode. Zie de nummering aan de linkerkant.")])]), _c('h3', [_vm._v("Periode verbergen")]), _c('p', [_vm._v("Er is ook de mogelijkheid om een hele periode te verbergen. Dit kunt u doen door op het oogje te klikken onderaan de periode. De leerlingen slaan de opdrachten van die periode dan over en kunnen met de volgende periode aan de slag.")]), _c('hr')]) : _vm._e(), _c('week-planner', {
    staticClass: "planner--kiempunt",
    attrs: {
      "allowMovingSelectedPeriods": false,
      "relativeToPeriods": true,
      "minWeeksInPast": _vm.isAdmin ? 10 : 1,
      "maxWeeksInFuture": 70,
      "classForWeek": _vm.classForWeek,
      "labelForWeek": _vm.labelForWeek,
      "allowEditInPast": _vm.isAdmin
    },
    on: {
      "clickedDate": _vm.chooseStartDate
    },
    model: {
      value: (_vm.plannerPeriods),
      callback: function($$v) {
        _vm.plannerPeriods = $$v
      },
      expression: "plannerPeriods"
    }
  }), _c('primary-button', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom",
      value: ('modal__footer'),
      expression: "'modal__footer'"
    }],
    attrs: {
      "loading": _vm.isSaving
    },
    on: {
      "clicked": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.isCreating ? 'Volgende' : 'Opslaan'))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e67ee02","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/groups/settings/Planning.vue
// module id = wyNJ
// module chunks = 0 1